import { RefObject } from 'react';
import { useLanguage } from './languageService';

    const useTextToSpeech = (audioRef: RefObject<HTMLAudioElement>) => {
      const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;  
      const { selectedLanguage } = useLanguage();

  const textToSpeech = async (text: string, onEndCallback?: () => void) => {
    const apiUrl = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`;

    const requestData = {
      input: {
        text: text,
      },
      voice: {
        languageCode: selectedLanguage,
        ssmlGender: 'FEMALE',
      },
      audioConfig: {
        audioEncoding: 'MP3',
      },
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`Erro na solicitação da API: ${response.statusText}`);
      }

      const data = await response.json();

      if (!data.audioContent) {
        throw new Error('A resposta da API não contém áudio válido.');
      }

      const audioContent = data.audioContent;
      if (audioRef.current) {
        audioRef.current.src = `data:audio/mp3;base64,${audioContent}`;
        audioRef.current.onended = () => {
          debugger;
          if (onEndCallback) {
            onEndCallback();
          }
        }

        // Adiciona tratamento de erro ao tentar reproduzir o áudio
        try {
          await audioRef.current.play();
        } catch (playError) {
          console.error('Erro ao tentar reproduzir o áudio:', playError);
        }
      }
    } catch (error) {
      console.error('Erro ao realizar a solicitação de conversão de texto em fala:', error);
    }
  };

  return {
    textToSpeech,
    // audioRef,
  };
};

export default useTextToSpeech;
